import { graphql, useStaticQuery } from "gatsby"

export type Footer = {
  image: {
    url: string
    alt: string
  }
  channel: {
    label: string
    facebook: string
    instagram: string
    medium: string
    youtube: string
  }
  contact: {
    label: string
    email: string
  }
  address: {
    label: string
    text: string
  }
}

export const useFooter = (): Footer => {
  const result = useStaticQuery(graphql`
  {
    prismic {
      allFooters {
        edges {
          node {
            address
            image
            channels_label
            facebook {
              ... on PRISMIC__ExternalLink {
                url
              }
            }
            contact_label
            contact_email
            instagram {
              ... on PRISMIC__ExternalLink {
                url
              }
            }
            youtube {
              ... on PRISMIC__ExternalLink {
                url
              }
            }
            medium {
              ... on PRISMIC__ExternalLink {
                url
              }
            }
            label
          }
        }
      }
    }
  }`)

  const { node } = result.prismic.allFooters.edges[0]

  return {
    image: {
      url: node.image.url,
      alt: node.image.alt
    },
    channel: {
      label: node.channels_label,
      facebook: node.facebook.url,
      instagram: node.instagram.url,
      medium: node.medium.url,
      youtube: node.youtube.url
    },
    address: {
      label: node.label,
      text: node.address
    },
    contact: {
      label: node.contact_label,
      email: node.contact_email
    }
  }
}
